import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MidLevelExamPageComponent } from './mid-level-exam-page/mid-level-exam-page.component';
import { SharedModule } from '../shared/shared.module';
import { SafeUrlPipeModule } from '../pipes/safe-url.pipe';
import { UserwaySyncModule } from '../shared/userway-sync.directive';
@NgModule({
  imports: [CommonModule, SharedModule, SafeUrlPipeModule, UserwaySyncModule],
  declarations: [MidLevelExamPageComponent]
})
export class MidLevelExamModule { }



// WEBPACK FOOTER //
// ./ts/app/mid-level-exam/mid-level-exam.module.ts